import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import ItemList from 'flarum/common/utils/ItemList';
import classList from 'flarum/common/utils/classList';
import app from 'flarum/forum/app';
export default class StatWidget extends Component {
  view() {
    return m("div", {
      class: classList('StatWidget', {
        'Categories-compactMobileModeEnabled': !!app.forum.attribute('categories.compactMobile')
      })
    }, this.content().toArray());
  }
  content() {
    const items = new ItemList();
    items.add('count', m("div", {
      class: "StatWidget-count"
    }, this.attrs.count), 100);
    items.add('label', m("div", {
      class: "StatWidget-label"
    }, m("span", {
      className: "Categories-showOnMobile"
    }, m(Icon, {
      name: this.attrs.icon
    })), m("span", {
      className: "Categories-hideOnMobile"
    }, this.attrs.label)), 80);
    return items;
  }
}
flarum.reg.add('fof-categories', 'forum/components/StatWidget', StatWidget);